import RentalCarList from './rental_car_list';

export default RentalCarList;
